var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info__item"},[_c('div',{staticClass:"item__name"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item__value"},[(!_vm.loading)?_vm._t("default"):_c('t-skeleton-loader',{attrs:{"type":"paragraph","width":"120px","height":"24px","border-radius":"32px"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }